// /terminos-y-condiciones — SSR head()
import { createFileRoute } from "@tanstack/react-router";
import TermsAndConditions from "@/pages/TermsAndConditions";
import { buildStaticHead, staticLoader, type StaticSEO } from "@/lib/static-route-seo";

const SEO: StaticSEO = {
  es: {
    title: "Términos y Condiciones | Fora da Rota",
    description:
      "Consulta los términos y condiciones de uso de Fora da Rota: reservas, pagos, cancelaciones y responsabilidades.",
  },
  "pt-BR": {
    title: "Termos e Condições | Fora da Rota",
    description:
      "Consulte os termos e condições de uso da Fora da Rota: reservas, pagamentos, cancelamentos e responsabilidades.",
  },
  en: {
    title: "Terms and Conditions | Fora da Rota",
    description:
      "Read Fora da Rota's terms and conditions: bookings, payments, cancellations and responsibilities.",
  },
  "en-EU": {
    title: "Terms and Conditions | Fora da Rota",
    description:
      "Read Fora da Rota's terms and conditions: bookings, payments, cancellations and responsibilities.",
  },
};

export const Route = createFileRoute("/terminos-y-condiciones")({
  loader: staticLoader,
  head: ({ loaderData }) =>
    buildStaticHead(SEO, "/terminos-y-condiciones", loaderData),
  component: TermsAndConditions,
});
